export const fromObjectToOptions = (dataObject) => {
    const options = [];

    for (const key in dataObject) {
        if (Object.prototype.hasOwnProperty.call(dataObject, key)) {
            options.push({ value: key, label: dataObject[key] });
        }
    }

    return options;
};
